import { postAPICall } from "../helpers/httpHelper";
import { db } from "../utils/db";

export const fetchEntityRelationships = async (params) => {
  let relationships = await fetchEntityRelationshipsFromLocal(params);
  if (!relationships?.length) {
    relationships = await fetchEntityRelationshipsFromDataBase(params);
  }
  return relationships;
};

export const fetchEntityRelationshipsFromLocal = async (params) => {
  return await db.entity_relationships
    .filter(
      (rel) =>
        rel.parent_entity_id == params.entityId ||
        rel.child_entity_id == params.entityId
    )
    .toArray();
};

export const fetchEntityRelationshipsFromDataBase = async (params) => {
  let response = await postAPICall(
    "GET",
    `/entities/${params.entityId}/relationships`
  );
  return response?.data;
};
